<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('apply.no')" prop="applyNo">
                    <el-input class="handle-input" v-model="queryCondition.applyNo" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('apply.applyType')" prop="applyType">
                    <el-select class="handle-input" v-model="queryCondition.applyType" clearable style="width:100%">
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option :key="index" v-for="(item,index) in applyTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('apply.subject')" prop="subject">
                    <el-input clearable class="handle-input" v-model="queryCondition.subject" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('apply.quotationType')" prop="quotationType">
                    <el-select clearable class="handle-input" v-model="queryCondition.quotationType" style="width:100%">
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option :key="index" v-for="(item,index) in quotationTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('apply.shortlistedSuppliers')" prop="supplierCode">
                      <el-input clearable class="handle-input" suffix-icon="el-icon-search" @click.native='showSelSupplierDialog=true;SupplierNameDialogReset = true' v-model="queryCondition.supplierCode" @clear="clearSupplierName" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('apply.roundStatus')" prop="roundStatus">
                      <el-select clearable class="handle-input" v-model="queryCondition.roundStatus" style="width:100%">
                        <el-option :label="$t('common.all')" value=""></el-option>
                        <el-option :key="index" v-for="(item,index) in roundStatusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item clearable label="创建日期(从)" prop="createDate">
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item clearable label="创建日期(至)" prop="createEndDate">
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createEndDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('common.createBy')" prop="buyerName">
                      <el-input clearable class="handle-input" v-model="queryCondition.buyerName" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryFormThis" type="primary">{{$t('common.reset')}}</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" v-acl="QuotationRoundInit" @click="showNewRoundDialogFunc">{{$t('apply.newRound')}}</el-button>
        <!--创建新轮次-->
        <el-button size="mini" class="btn" type="primary" v-acl="QuotationCloseQuotation" @click="endQuotationFunc">{{$t('apply.endQuotaion')}}</el-button>
        <!--结束询价-->
        <el-button size="mini" class="btn" type="primary" v-acl="QuotationRecoveryQuotation" @click="recoveryQuotationFunc">{{$t('apply.resumeQuotation')}}</el-button>
        <!--恢复询价-->
        <el-button size="mini" class="btn" type="primary" v-acl="SourcingQuerySubmitData" @click="createSourcing">{{$t('apply.confirmPrice')}}</el-button>
        <!--价格确认-->
        <el-button size="mini" class="btn" type="primary" v-acl="LineQuotationHistoryExport" @click="onExport">{{$t('common.export')}}</el-button>
        <!-- 导出 -->
      </el-row>
      <!--=========数据列表================-->
      <el-table sortable max-height="435" row-key="ttQuotationApplyRoundId" :data="quotationList" @selection-change="handleSelectionChange" ref="quotationDataTable" border highlight-current-row class="table">
        <el-table-column align="center" fixed prop="ttQuotationApplyRoundId" :reserve-selection="true" :selectable="selectInit" type="selection" width="55" :label="$t('common.select')"></el-table-column>
        <!--单据编号-->
        <el-table-column show-overflow-tooltip align="center" fixed sortable prop="applyNo" :label="$t('apply.no')" min-width="100px">
          <template slot-scope="scope">
            <el-link type="primary" @click="openQuotationApplyDetail(scope.row)"> {{scope.row.applyNo}} </el-link>
          </template>
        </el-table-column>
        <!--类型-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="applyTypeI18n" :label="$t('apply.applyType')" min-width="90px"></el-table-column>
        <!--主题-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="subject" :label="$t('apply.subject')" min-width="180px"></el-table-column>
        <!--入围供应商-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="supplierNames" :label="$t('apply.shortlistedSuppliers')" min-width="180px"></el-table-column>
        <!--报价类型-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="quotationTypeI18n" :label="$t('apply.quotationType')" min-width="90px"></el-table-column>
        <!--操作-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="roundNumber" :label="$t('common.operation')" min-width="80px">
          <template slot-scope="scope">
            <el-link type="primary" v-if="scope.row.roundStatus!=='4'" @click="openQuotationDetail(scope.row)">{{$t('common.quote')}}</el-link>
            <!--报价-->
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" sortable prop="roundNumber" :label="$t('apply.round')" min-width="80px">
          <!--轮次-->
          <template slot-scope="scope">
            <el-link type="primary" @click="openQuotationHistory(scope.row.ttQuotationApplyId)"> {{scope.row.roundNumber}} </el-link>
          </template>
        </el-table-column>
        <!--轮次状态-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="roundStatusI18n" :label="$t('apply.roundStatus')" min-width="100px"></el-table-column>
        <!--创建人-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="name" :label="$t('common.createBy')" min-width="100px"></el-table-column>
        <!--创建日期-->
        <el-table-column show-overflow-tooltip align="center" sortable prop="createDate" :label="$t('common.createDate')" min-width="100px"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <!--=========数据列表END================-->
    <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
      <SelSupplier :multipleSelectionFlag="false" v-if="SupplierNameDialogReset" ref="supplierSelRef" @subCallMethod="selectSupplierMethod"></SelSupplier>
    </el-dialog>
    <!--新轮次创建-->
    <el-dialog :title="$t('apply.newRound')" :visible.sync="showNewRoundDialog" width="65%">
      <!--创建新轮次-->
      <el-form ref="pickupPointForm" class="form_border" :label-position="labelPosition" label-width="120px">
        <div class="handle-box">
          <el-row>
            <el-button size="mini" type="primary" v-acl="QuotationCreateNewRound" @click="saveNewRoundFunc" v-if="showSaveNewRoundFlag">{{$t('common.submit')}}</el-button>
            <!--提交-->
          </el-row>
          <el-form :model="newRoundHeadData" :label-position="labelPosition" ref="newRoundHeadDataForm" label-width="140px">
            <el-row :gutter="5">
              <el-col :span="7">
                <el-form-item :label="$t('apply.no')">
                  <!--单据编号-->
                  <el-input v-model="newRoundHeadData.applyNo" :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item :label="$t('apply.applyType')" prop="applyType">
                  <!--类型-->
                  <el-select v-model="newRoundHeadData.applyType" :disabled="true">
                    <el-option :key="index" v-for="(item,index) in applyTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="7">
                <el-form-item :label="$t('apply.subject')">
                  <!--主题-->
                  <el-input v-model="newRoundHeadData.subject" :disabled="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="5">
              <el-col :span="7">
                <el-form-item :label="$t('apply.quotationType')" prop="quotationType">
                  <!--报价类型-->
                  <el-select v-model="newRoundHeadData.quotationType" :disabled="true">
                    <el-option :key="index" v-for="(item,index) in quotationTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item :label="$t('apply.round')">
                  <!--轮次-->
                  <el-input v-model="newRoundNumber" :disabled="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="5">
              <el-col :span="18">
                <el-form-item :label="$t('apply.roundRemark')">
                  <!--轮次说明-->
                  <el-input type="textarea" v-model="roundRemark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="5">
              <el-col :span="18">
                <el-form-item :label="$t('common.attachment')" size="small">
                  <!--附件-->
                  <el-upload class="upload-demo" ref="upload" :headers="header" :action="fileUploadUrl" :on-success="uploadSuccess" :on-remove="handleRemove" multiple>
                    <el-button size="mini" type="primary">{{$t('common.selectFile')}}</el-button>
                    <!--选取文件-->
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="5">
              <el-col :span="18">
                <el-table :data="supplierList" ref="supplierListDataTable" border highlight-current-row>
                  <el-table-column prop="supplierCode" :label="$t('apply.supplierCode')"></el-table-column>
                  <!--供应商编号-->
                  <el-table-column prop="supplierName" :label="$t('apply.supplierName')"></el-table-column>
                  <!--供应商名称-->
                  <!--本轮是否发放-->
                  <el-table-column width="55px" prop="tmSupplierId" :selectable="selectableMethod" type="selection" :label="$t('apply.whetherToIssue')"></el-table-column>
                </el-table>
              </el-col>
            </el-row>

          </el-form>
        </div>
      </el-form>
      <!--新轮次创建-->

    </el-dialog>

    <!--========= 报价确认提交 =========-->
    <el-dialog :title="$t('quoteByLine.sourcing.submitTitle')" :visible.sync="showSourcingDialog" append-to-body width="80%">
      <SelSourcing :sourcingList=sourcingList ref="sourcingRef"></SelSourcing>
    </el-dialog>
    <!--========= 报价确认提交结束 =========-->

    <el-dialog title="以下申请单报价明细的预估年总费用没有维护请维护后再进行结束询价" :visible.sync="showNewErrorDialog" width="660px">
      <!--创建新轮次-->
      <el-card class="box-card">
        <div class="handle-box">
          <el-table sortable :close-on-click-modal="false" :data="errorList" style="width:100%" border highlight-current-row class="table">
            <el-table-column align="center" ali sortable prop="applyNo" label="申请单编号"></el-table-column>
          </el-table>
        </div>
      </el-card>
    </el-dialog>

  </div>
</template>
<script>
import { quotationSearchService } from "../../../api/quotation-apply/quotation-search";
import { inputChoiceService } from "../../../api/common/input-choice";
import commonFunction from "../../../utils/dataTableUtils"
import SelSupplier from '../base-data/carrier-sel-page'
import commonConstatns from "@/constants/commonConstants"
import SelSourcing from './sourcing-select';
import { querySubmitData } from "@/api/line/sourcing";
import store from '@/store/index'
import paginationMixin from '@/mixins/pagitionMixin';
import { fileService } from "@/api/common/file-utils";

import { Message } from "element-ui";
export default {
  name: 'quotation-search',
  mixins: [paginationMixin],
  components: {
    SelSupplier, SelSourcing
  },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      SupplierNameDialogReset: false,
      totalCount: 0,
      quotationList: [],
      labelPosition: 'right',
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        applyType: null,
        subject: null,
        quotationType: null,
        supplierCode: null,
        roundStatus: null,
        createDate: null,
        createEndDate: null,
        buyerName: null,
        roundNumber: null,
        tmSupplierId: null
      },
      roundStatusList: [],
      quotationStatusList: [],
      sourcingStatusList: [],
      quotationTypeList: [],
      applyTypeList: [],
      showSelSupplierDialog: false,
      showNewRoundDialog: false,

      newRoundHeadData: {},
      supplierList: [],
      newRoundNumber: null,
      ttQuotationApplyId: null,
      roundRemark: '',

      //创建报价确认
      showSourcingDialog: false,
      sourcingList: [],

      showSaveNewRoundFlag: true,
      fileUploadUrl: commonConstatns.fileUploadUrl,
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      uploadFiles: [],
      newRoundMCDFlag: true,
      radioVal: null,
      selectRow: null,
      showNewErrorDialog: false,
      errorList: [],
      multipleSelection: [],
      applyIds: []
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    quotationSearchService.getQuotationListData(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.quotationList = res.resultData;
        vm.totalCount = res.totalCount;
      })
    })
  },
  created() {
    //this.queryData(1);
    this.getInputChoiceValues();
  },
  methods: {
    selectInit(row, index) {
      if (row.roundStatus === '4') {
        return false
      } else {
        return true
      }
    },
    onExport() {
      var reqData = Object.assign({}, this.queryCondition)
      this.$set(reqData, 'applyIds', this.applyIds)
      quotationSearchService.onExport(reqData).then((res) => {
        fileService.respToFile(res, 'RFQ(Line)Report.xlsx');
      })
    },
    handleSelectionChange(val) {
      this.applyIds = []
      this.multipleSelection = val;
      val.forEach(ele => {
        this.applyIds.push(ele.ttQuotationApplyId)
      })
    },
    //页面数据查询
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      quotationSearchService.getQuotationListData(this.queryCondition).then((res) => {
        this.quotationList = res.resultData;
        this.totalCount = res.totalCount;
        this.$refs.quotationDataTable.clearSelection();
      });
    },
    //打开报价详情
    openQuotationDetail: function (row) {
      //如果供应商还未报价给出提醒（当前轮次还没有进行代供应商报价!）
      let quotationType = row.quotationType;
      let ttQuotationId = row.ttQuotationId;
      if (quotationType == 'SUP' && ttQuotationId == null) {
        Message({ message: "当前轮次供应商还未进行报价!", type: "warning" });
        return;
      }
      if (this.actionCheck.actionCheck('QuotationInit') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false

      }
      this.$router.replace({ name: 'quotationDetail', params: { roundId: row.ttQuotationApplyRoundId, from: 'q' } });
    },
    //报价历史查看
    openQuotationHistory: function (applyId) {
      if (this.actionCheck.actionCheck('QuotationHistory') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false

      }
      this.$router.replace({ name: 'quotationHistory', params: { applyId: applyId } });
    },
    //线路报价申请单详情
    openQuotationApplyDetail: function (row) {
      if (this.actionCheck.actionCheck('ApplyInfo') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false

      }
      this.$router.replace({ name: 'applyDetail', params: { applyId: row.ttQuotationApplyId, source: 'quotation' } });
    },
    //文件上传成功回调
    uploadSuccess: function (response, file, fileList) {
      this.uploadFiles.push(...response.data);
    },
    handleRemove: function (file, fileList) {
      this.uploadFiles = [];
      fileList.forEach((item) => {
        this.uploadFiles.push(...item.response.data)
      })
    },
    /**
     * 结束询价，只有报价完成的单据可以结束报价，结束报价后可以进行报价确认操作
     */
    endQuotationFunc: function () {
      let _this = this;
      let rows = _this.$refs.quotationDataTable.selection;
      let ids = [];
      if (rows.length == 0) {
        //请选择需要结束的询价！
        Message({ message: this.$t('apply.selectEndQuote'), type: "warning" });
        return;
      } else {
        for (let index in rows) {
          let rwoData = rows[index];
          if (_this.applyStatusCloseWarning(rwoData.status)) { return; }
          if (!rwoData.ownerFlag) {
            Message({ message: "只能操作自己名下的单据", type: "warning" });
            return;
          }
          if (rwoData.quotationStatus == '3' && rwoData.roundStatus == '2') {
            Message({ message: "恢复询价后不可进行再继续结束询价!请进行新轮次创建!", type: "warning" });
            return;
          }
          //收集可以结束的报价ID(只有报价完的才可以结束报价)
          if (rwoData.quotationStatus != '2') {
            //请选择报价状态为报价完成的单据进行操作！
            Message({ message: this.$t('apply.selectCompletedQuotationStatus'), type: "warning" });
            return;
          }
          ids.push(rwoData.ttQuotationId);
        }
      }

      quotationSearchService.endQuotation(ids).then((res) => {
        if (res.meta.success) {
          //_this.selectRow = null;
          // _this.radioVal = null;
          //结束询价成功
          Message({ message: this.$t('apply.closeRFQSuccess'), type: "success" });
          this.queryData();
        } else {
          if (res.data.length == 1) {
            Message({ message: '报价明细的预估年总费用没有维护请维护后再进行结束询价!', type: "warning" });
            //转到报价详情，让用户维护预估年总费用
            let roundId = res.data[0].roundId;
            this.$router.replace({ name: 'quotationDetail', params: { roundId: roundId, from: 'eq' } });
          } else {
            _this.errorList = res.data;
            _this.showNewErrorDialog = true;
            //重新获取
            if (ids.length != res.data.length) {
              this.queryData();
            }
          }
        }

      })
    },
    /*
    恢复询价:只能恢复最新轮次，且轮次状态为结束询价的
    */
    recoveryQuotationFunc: function () {
      let _this = this;
      let rows = _this.$refs.quotationDataTable.selection;
      let ids = [];
      if (rows.length == 0) {
        //请选择需要恢复的询价！
        Message({ message: this.$t('apply.selectResumeQuote'), type: "warning" });
        return;
      } else if (rows.length > 1) {
        Message({ message: "恢复询价只允许进行单一操作，不允许多选!", type: "warning" });
        return;
      } else {
        let rowData = rows[0];
        if (_this.applyStatusCloseWarning(rowData.status)) { return; }
        if (!rowData.ownerFlag) {
          Message({ message: "只能操作自己名下的单据", type: "warning" });
          return;
        }
        //收集可以进行恢复报价ID(只有结束报价的才可以恢复报价)
        if (rowData.roundStatus == '3' && rowData.isLastRound == 'Y') {
          ids.push(rowData.ttQuotationId);
        }
        if (ids.length == 0) {
          //只有最新轮次且轮次状态为结束询价的才能进行恢复操作！
          Message({ message: this.$t('apply.resumeQuoteCondition'), type: "warning" });
          return;
        }
      }
      quotationSearchService.recoveryQuotation(ids[0]).then((res) => {
        //_this.radioVal = null;
        //_this.selectRow = null;
        //恢复询价成功
        Message({ message: this.$t('apply.resumeRFQSuccess'), type: "success" });
        this.queryData();
      })
    },
    /**
     * 创建新轮次:轮次状态报价完成的且为最新轮次
     */
    showNewRoundDialogFunc: function () {
      let _this = this;
      _this.uploadFiles = [];
      let rows = _this.$refs.quotationDataTable.selection;
      if (rows.length == 0) {
        //请选择需创建新轮次的询价！
        Message({ message: this.$t('apply.selectNewRoundQuote'), type: "warning" });
        return;
      }
      if (rows.length > 1) {
        Message({ message: "创建新轮次只允许进行单一创建，不允许多选!", type: "warning" });
        return;
      }
      let quotation = rows[0];
      if (_this.applyStatusCloseWarning(quotation.status)) { return; }
      if (!quotation.ownerFlag) {
        Message({ message: "只能操作自己名下的单据", type: "warning" });
        return;
      }
      if (!(quotation.roundStatus == '2' && quotation.isLastRound == 'Y')) {
        //只有报价完成且最新轮次才可以进行新轮次创建！
        Message({ message: this.$t('apply.newRoundCondition'), type: "warning" });
        return;
      }
      _this.newRoundNumber = null;
      _this.roundRemark = '';
      _this.ttQuotationApplyId = null;
      quotationSearchService.roundInit(quotation).then((res) => {
        if (res.quotationApply.source == 'SUP') {//如何申请单是供应商创建的则不可以编辑供应商
          _this.newRoundMCDFlag = false;
        }
        _this.$refs.quotationDataTable.clearSelection();
        _this.newRoundHeadData = res.quotationApply;
        _this.supplierList = res.supplierList;
        _this.newRoundNumber = res.roundNumber;
        _this.ttQuotationApplyId = res.ttQuotationApplyId;
        _this.showNewRoundDialog = true;
        _this.supplierList.forEach(row => {
          _this.$nextTick(() => {
            _this.supplierList.forEach(row => {
              _this.$refs.supplierListDataTable.toggleRowSelection(row, true);
            })
          })
        })
      })

    },
    selectableMethod: function (row) {
      return this.newRoundMCDFlag;
    },
    //新轮次创建
    saveNewRoundFunc: function () {
      let _this = this;
      //判断是否选择了供应商
      let rows = this.$refs.supplierListDataTable.selection;
      if (rows.length == 0) {
        //请选择需要发放的供应商
        Message({ message: this.$t('apply.selectPublishSupplier'), type: "warning" });
        return;
      }
      this.showSaveNewRoundFlag = false;
      let supIds = [];
      rows.forEach((item) => {
        supIds.push(item.tmSupplierId);
      });
      let quotationInfo = {};
      quotationInfo.roundNumber = this.newRoundNumber;
      quotationInfo.roundRemark = this.roundRemark;
      quotationInfo.supplierIds = supIds;
      quotationInfo.listDoc = this.uploadFiles;
      quotationInfo.ttQuotationApplyId = this.ttQuotationApplyId;
      quotationSearchService.createNewRound(quotationInfo).then((res) => {
        //_this.radioVal = null;
        //_this.selectRow = null;
        //创建成功
        Message({ message: this.$t('common.createSuccess'), type: "success" });
        _this.showNewRoundDialog = false;
        _this.queryData();
        _this.showSaveNewRoundFlag = true;
      }).catch((error) => {
        _this.showSaveNewRoundFlag = true;
      })
    },
    selectSupplierMethod: function (supList) {
      this.queryCondition.supplierCode = supList[0].supplierName;
      this.queryCondition.tmSupplierId = supList[0].tmSupplierId;
      this.showSelSupplierDialog = false;
    },
    //查询条件重置方法
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        applyType: null,
        subject: null,
        quotationType: null,
        supplierCode: null,
        roundStatus: null,
        createDate: null,
        createEndDate: null,
        buyerName: null,
        roundNumber: null,
        tmSupplierId: null
      }
      this.$refs.quotationDataTable.clearSelection();
      this.queryData();
    },
    applyStatusCloseWarning: function (status) {
      if (status == '3') {
        Message({ message: "此单据号为作废状态，无法操作！", type: "warning" });
        return true;
      }
      return false;
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY_ROUND:ROUND_STATUS"] = "TT_QUOTATION_APPLY_ROUND:ROUND_STATUS";
      mapObj["TT_QUOTATION:STATUS"] = "TT_QUOTATION:STATUS";
      mapObj["TT_SOURCING:STATUS"] = "TT_SOURCING:STATUS";
      mapObj["TT_QUOTATION_APPLY:QUOTATION_TYPE"] = "TT_QUOTATION_APPLY:QUOTATION_TYPE";
      mapObj["TT_QUOTATION_APPLY:APPLY_TYPE"] = "TT_QUOTATION_APPLY:APPLY_TYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.roundStatusList = res["TT_QUOTATION_APPLY_ROUND:ROUND_STATUS"];
        this.quotationStatusList = res["TT_QUOTATION:STATUS"];
        this.sourcingStatusList = res["TT_SOURCING:STATUS"];
        this.quotationTypeList = res["TT_QUOTATION_APPLY:QUOTATION_TYPE"];
        this.applyTypeList = res["TT_QUOTATION_APPLY:APPLY_TYPE"];
      });
    },
    createSourcing: function () {
      let _this = this;
      let rows = _this.$refs.quotationDataTable.selection;
      if (rows.length == 0) {
        //请选择需要价格确定的询价！
        Message({ message: this.$t('apply.selectPriceDetermination'), type: "warning" });
        return;
      } else if (rows.length > 1) {
        Message({ message: "价格确认只允许进行单一操作，不允许多选!", type: "warning" });
        return;
      } else {
        let rowData = rows[0];
        //只有最新轮次，报价状态为询价结束，轮次状态为询价结束时才可以进行价格确认
        if (_this.applyStatusCloseWarning(rowData.status)) { return; }
        if (!(rowData.quotationStatus == '3' && rowData.roundStatus == '3' && rowData.isLastRound == 'Y')) {
          //请确认询价结束
          Message({ message: this.$t('apply.pleaseConfirmEndQuote'), type: "warning" });
          return;
        } else {
          let ttQuotationId = rowData.ttQuotationId;
          querySubmitData(ttQuotationId).then((res) => {
            if (res.totalCount < 0) {
              //轮次已报价确认
              Message({ message: this.$t('apply.roundsFixed'), type: "warning" });
              return;
            } else if (res.totalCount == 0) {
              //已创建新轮次,不能报价确认
              Message({ message: this.$t('apply.canNotConfirm'), type: "warning" });
              return;
            }
            this.$router.push({
              path: `/sourcing-submit`,
              query: {
                ttQuotationId: rowData.ttQuotationId,
              }
            });
          })
        }
      }
    },
    checkRoundNumber: function (val) {
      if (undefined != val) {
        let reg = /^(0|[1-9]\d{0,9})$/;
        if (!reg.test(val)) {
          this.queryCondition.roundNumber = 1;
        }
      }
    },
    clearSupplierName() {
      this.SupplierNameDialogReset = false
      this.queryCondition.tmSupplierId = null
      this.$nextTick(() => {
        this.SupplierNameDialogReset = true
      })
    }
  },
  extends: commonFunction
}
</script>
<style scoped >
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
.el-select {
  width: 100%;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
</style>
